import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { EntityService } from '@services/core/entity.service';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

export const entitiesResolver: ResolveFn<any> = () => {
  const entityService = inject(EntityService)
  return fetchEntities(entityService)
}

function fetchEntities(entityService: EntityService) {
  return forkJoin({
    entities: entityService.getEntities(),
    auditors: entityService.getAuditors()
  }).pipe(
    map((data) => buildEntities(data))
  )
}

function buildEntities(data: any) {
  return {
    entities: data.entities,
    entitiesTemp: data.entities,
    auditors: data.auditors
  };
}
